import React from 'react';
import Logo from './components/logo';
import './index.less';
import GlobalSearch from '@/pages/operate-platform/components/global-search';
import FeedBack from './components/feedback';
import UserInfo from './components/user-info';
import { Divider, Space } from '@drip/drip-design';
import useTopGlobalNavCollapsedChange from '@/hooks/useTopGlobalNavCollapsedChange';
import classnames from 'classnames';
import CommonAsk from '@/pages/operate-platform/components/common-ask';
import { connect } from 'react-redux';
import AIAutobots from '../AIAutobots';

function TopGlobalNavigation(props: any) {
  const [topGlobalNavCollapsed] = useTopGlobalNavCollapsedChange(true, false);
  // const [topGlobalNavCollapsed] = [true];

  if (window !== window.top || props.roleIsKf) {
    return props.children;
  }

  // 设置顶部导航的高度，用来通知页面顶部样式调整
  const { ACORE = {} } = window;
  (ACORE as any).TOP_GLOBAL_NAV_HEIGHT = 72;

  return (
    <div className={classnames('global-nav-wrapper', { 'global-nav-wrapper-collapsed': topGlobalNavCollapsed })}>
      <div className={classnames('acore-top-global-navigation', { 'top-global-nav-collapsed': topGlobalNavCollapsed })}>
        <div className="top-navigation-left">
          <Space size={[20, 0]} align="center" split={<Divider style={{ margin: 0, height: 24 }} type="vertical" />}>
            <Logo />
            <CommonAsk />
          </Space>
        </div>
        <div className="top-navigation-right">
          <Space align="center" size={[24, 0]}>
            <GlobalSearch />
            <FeedBack />
            <UserInfo />
          </Space>
        </div>
      </div>
      <AIAutobots />
      {props.children}
    </div>
  );
}

export default connect((state: any) => {
  return {
    roleIsKf: state.userInfo?.roles?.some((role: any) => role.roleId === 26),
  };
})(TopGlobalNavigation);
